import { Component, Input, inject } from '@angular/core';
import { AuthService } from '../../../../shared';
import { Router } from '@angular/router';
import { GaService, ProductService } from '../../../../services';

@Component({
  selector: 'app-my-navigation',
  templateUrl: './my-navigation.component.html',
  styleUrls: ['./my-navigation.component.scss'],
  standalone: false,
})
export class MyNavigationComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private gaService = inject(GaService);
  private productService = inject(ProductService);

  @Input() currentPage: string;

  signout() {
    this.authService.signout();
    this.productService.selectProducts = [];
    this.gaService.logLogout();
    this.router.navigate(['/signin']);
  }
}
